import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { POInvoiceDetails } from '../types/POInvoiceDetails';

export const useGetPOInvoice = (poInvoiceID?: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        enabled: !!poInvoiceID,
        queryKey: ['po-invoice', poInvoiceID],
        queryFn: async () => await apiClient.get('purchase-order/invoice',
            {
                params: {
                    poInvoiceID: poInvoiceID
                }
            }) as POInvoiceDetails
    });

    return {
        data,
        isLoading,
        refetch,
        isRefetching
    };
};
